import { connect } from "react-redux";

var AnswerWritingInterface = require("components/writing/answers/AnswerWritingInterface");
var MultiPartSentenceStarter = require("components/writing/questions/MultiPartSentenceStarter");
var Autosaver = require("components/writing/quizzes/Autosaver");
var Spinner = require("components/utility/Spinner");
var StepProgressMeter = require("components/utility/StepProgressMeter");
var StudentAvatar = require("components/avatars/StudentAvatar");
var TopicQuestion = require("components/writing/quizzes/warmups/TopicQuestion");
var BookTextVariety = require("components/reading/books/BookTextVariety");

var GradeLevel = require("lib/academic/GradeLevel");
var TextTypes = require("lib/academic/TextTypes");
var ZPDRange = require("lib/academic/ZPDRange");
var ArbitrarySubjects = require("lib/data/ArbitrarySubjects");
var BookDisplay = require("components/reading/books/BookDisplay")

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var WritingActions = require("lib/actions/WritingActions");
var RosterActions = require("lib/actions/RosterActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");

var AccountPlans = require("lib/account/AccountPlans");
var QuestionTypes = require("lib/academic/QuestionTypes");
var MyShelfRouting = require("lib/routing/MyShelfRouting");

var CurrentUser = require("lib/account/CurrentUser");
var StudentOnboardingModal = require("components/users/students/onboarding/StudentOnboardingModal");

require('writing/quizzes/quiz_page.scss');

@connect(
	(state, props) => {
		var textID = $wr.getURLParameterByName("text_id");

		var book = ReadingSelectors.book({ state, id: textID });

		var user = CurrentUser.get()

		var downProps = { book };

		downProps.userPrefs = user.prefs;

		downProps.loading = WritingSelectors.isLoadingQuestions({ state, key: "index" }) ||
			WritingSelectors.isLoadingQuizzes({ state, key: "update" });
		// Note not answers update. We track that in state instead... Why?
		// Some reason. Maybe so we can recover from autosave failing

		var quiz = WritingSelectors.quizzes({ state, filters: { text_id: textID } })[0];

		if (quiz) {
			downProps.quiz = quiz;
			downProps.answers = WritingSelectors.answersForQuizID({ state, quizID: quiz.id });
			if (!CurrentUser.isPremiumOrTrialAccount()) {
				downProps.answers = _.filter(downProps.answers, answer => { return answer.question_type !== QuestionTypes.FILL_IN_THE_BLANK_QUESTION })
			}
			downProps.questions = _.map(downProps.answers, (answer) => {				
				return WritingSelectors.question({ state, id: answer.question_id });
			})
		}

		if (!user.prefs.automatic_zpd_exclusion) {
			downProps.shouldExclude = false;
		} else if (!book) {
			downProps.shouldExclude = false;
		} else if (!book.lexile_score) {
			downProps.shouldExclude = true;
		} else {
			var zpdStatus = ZPDRange.getTextStatus(
				book.lexile_score, user.current_reading_level
			);

			downProps.shouldExclude = zpdStatus == ZPDRange.UNDER;
		}

		downProps.canTakeQuiz = $wr.canStudentTakeQuiz(user)

		return downProps;
	},
	(dispatch, props) => {
		var userID = CurrentUser.get().id
		var textID = $wr.getURLParameterByName("text_id");
		LuckyOrangeClient.tagComponent("text_id:" + textID);

		function fetchText() {
			// Have to make sure the text loads in, otherwise we won't be
			// able to use the title to customize feedback
			dispatch(ReadingActions.fetchBookSynchronously({ id: textID, userID: userID })).then((response) => {
				if (response.books && response.books.length > 0){
					fetchQuizzes(response.books[0]) 
				}
			});
		}
		// Step A: Fetch any quizzes, look to see if are drafts
		function fetchQuizzes(book) {
			// Fetch all quizzes, draft or non-draft, for this text (there should only be 0 or 1)
			dispatch(WritingActions.fetchQuizzes({
				conditions: { textID, allowDraft: true, startDate: 'any' },
				embeds: ["quiz.answers", "answer.question",
					"question.starters", "question.answer_options",
					"answer.meta_data", "answer.history"],
			})).then((response) => {
				// ONLY create QUIZ if NO QUIZZES FOR TEXT ID AND USER AND TEXT VARIETY SUPPLIED

				if (_.isEmpty(response.quizzes)) {
						createNewQuiz(book);
					
				} else {
					var quiz = response.quizzes[0];
					if (!(quiz.draft || quiz.allow_revision)) {
						window.wrNotifications.triggerDropDownNotification({
							text: "You've already done a quiz for this text!", icon: "ok" });

						$wr.redirect(MyShelfRouting.getPath({
							activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
							detailsView: "quizzes",
							textID: textID
						}));

					} else {
						checkQuiz(quiz,book);
					}
				}
			});
		}

		// Step A.1: Check for malformed quizzes
		function checkQuiz(quiz, book) {
			if (_.isEmpty(quiz.answers) && book.text_variety) {
				createQuizAnswers(quiz.id, {text_variety: book.text_variety});
			}
		}

		// Step B: If we didn't find any drafts, make a new quiz draft
		function createNewQuiz(book) {
			if (book.text_variety) {
				var quizData = { text_id: textID, draft: true, text_variety: book.text_variety };
				dispatch(ReadingActions.invalidateBookCache({}));
				return dispatch(WritingActions.createQuiz({
					quiz: quizData
				})).then((response) => {
					// CREATE ANSWERS DIRECTLY AFTER QUIZ IS CREATED
					createQuizAnswers(response.quizzes[0].id, {text_variety: book.text_variety})
				});
			}
		}

		function updateQuiz(quizID, quizData, embeds, queryParams) {
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.updateQuiz({
				id: quizID, update: quizData, embeds: embeds, query: queryParams
			}));

		}

		function createQuizAnswers(quizID, quizData)  {
			var queryParams = {
				draft_answers: true,
			}

			var embeds = ["quiz.answers", "answer.meta_data", "answer.history",
				"answer.question", "question.starters", "question.answer_options"];

			return updateQuiz(quizID, quizData, embeds, queryParams);
		}

		function deleteQuiz(quizID) {
			var update = {"activity:any:any": null};
			dispatch(ReadingActions.localUpdateBook({id: textID, update}));
			dispatch(ReadingActions.invalidateBookCache({}));
			return dispatch(WritingActions.deleteQuiz({ id: quizID }));
		}

		return {
			populateData: fetchText,

			getNewQuestion: (query, embeds) =>
				dispatch(WritingActions.fetchQuestions({ query, embeds })),
			createNewQuiz, createQuizAnswers, updateQuiz, deleteQuiz,
			updateAnswer: (answerID, answerData) =>
				dispatch(WritingActions.updateAnswer({ id: answerID, update: answerData })),
		}
	}
)

class QuizPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("QuizPage");

		this.state = {
			answerSaving: false,
			autosaveLoading: false,
			questionIndex: 0,
		}
	}

	textID() {
		return $wr.getURLParameterByName("text_id");
	}

	hasTextVariety(){
		if (this.props.books){
			return this.props.books.text_variety
		}
	}	
	quizHasWrittenContent() {
		var genericAnswers = _.select(this.props.answers, (answer) => { 
			return answer.question_type == "generic-question"
		})
		var hasContent = _.map(genericAnswers, (answer) => {
			var body = _.map(_.select(answer.parts, (part) => {
				return  part.type == "body"
			}), (part) => { return part.text }).join("")
			return body != ""
		})
		return hasContent.includes(true)
	}

	sentenceStarterCount() {
		return this.props.userPrefs.sentence_starter_count;
	}

	isLoading(ignoreAutosave) {
		return this.props.loading || this.state.answerSaving || 
			(this.state.autosaveLoading && !ignoreAutosave);
	}

	quizID() {
		if (this.props.quiz) {
			return this.props.quiz.id;
		}
	}

	isLastQuestion() {
		if (this.props.questions) {
			return this.state.questionIndex + 1 == this.props.questions.length;			
		}
	}

	getPhase() {
		// if we are loading and on the final question, we have just submitted our final answer
		if (this.isLastQuestion() && (this.isLoading(true) || !this.props.quiz.draft)) {
			return this.props.questions.length + 1;
		} else {
			return this.state.questionIndex + 1;
		}
	}

	//we want a method to call when we are done answering the text variety section
	//It should call create quiz
	submitTextVariety(data){
		if (!this.props.quiz) {
			this.props.createNewQuiz({text_variety: data.value})
		} else if (_.isEmpty(this.props.quiz.answers)) {
			this.props.createQuizAnswers(this.quizID(),{text_variety: data.value})
		}
		
		
	}
	
	getUpdatedAnswers(currentAnswerText, autograderData) {
		var answer = this.props.answers[this.state.questionIndex];

		var updatedAnswer = _.extend({}, answer, {
			body: currentAnswerText, autograderData: autograderData
		});
		var updatedAnswerList = _.clone(this.props.answers);
		updatedAnswerList[this.state.questionIndex] = updatedAnswer;

		return updatedAnswerList;
	}

	onAnswerComplete() {
		if (this.isLoading()) {
			return;
		}

		this.setState({ answerSaving: true }, () => {
			this.saveCurrentAnswer((success) => {
				if (success) {
					if (this.isLastQuestion()) {
						this.finalizeQuiz();
					} else {
						this.toNextQuestion();
					}
				} else {
					// There was an error saving, let the user try again
					this.setState({ answerSaving: false });
				}
			});
		});
	}
	hasEmptyParts(answer) {
		var answerParts = answer.parts
		if (!answerParts) {
			return true;
		}
		return _.any(answerParts, (part) => {
			return (!part.text) || (part.text.trim().length == 0);
		});
	}
	saveCurrentAnswer(callback) {	
		var answer = this.props.answers[this.state.questionIndex];

		if (answer.sessionMetaData) {
			if (_.isEmpty(answer.meta_data)) {
				// First time saving the answer; Make a new meta data array
				var metaData = [answer.sessionMetaData];
			} else {
				var metaData = _.clone(answer.meta_data);
				if (_.last(metaData).session_start != answer.sessionMetaData.session_start)	{
					// First time saving the answer this session, but was loaded from draft
					// Push new meta data onto the array
					metaData.push(answer.sessionMetaData);
				} else {
					// Update this session's meta data
					metaData[metaData.length - 1] = answer.sessionMetaData;
				}
			}
		}

		var answerData = {
			draft: this.props.quiz.draft,
			parts: (answer.localParts || answer.parts),
			meta_data: metaData,
			history: answer.history
		};

		var currentAnswerID = answer.id;
		this.props.updateAnswer(currentAnswerID, answerData).then(callback).catch(callback)
	}

	autosaveDraft(callback) {
		this.setState({ autosaveLoading: true }, () => {
			this.saveCurrentAnswer(() => {
				this.setState({ autosaveLoading: false })
				if (callback) { callback() }
			});			
		});
	}

	deleteDraft() {
		window.wrNotifications.triggerDropDownNotification({
			title: "Your draft has been deleted!", text: "", icon: "trash" });

		this.props.deleteQuiz(this.quizID());
		$wr.redirect("/");
	}

	finalizeQuiz() {
		var quizData = {
			draft: false,
			allow_revision: false,
		};

		// Don't update excluded status if this a revision
		if (!this.props.quiz.allow_revision) {
			quizData.excluded = this.props.shouldExclude;
		}

		var queryParams = { autograder_data: {} }

		_.each(this.props.answers, (answer) => {
			queryParams.autograder_data[answer.id] = answer.recentAutograderData;
		});

		LuckyOrangeClient.tagComponent("completed_quiz");
		this.props.updateQuiz(this.quizID(), quizData, ["quiz.evaluation"], queryParams).then((response) => {
			var quiz = _.first(response.quizzes)
			if (quiz && quiz.evaluation) {
				if (quiz.evaluation.filtered) {
					var notification = "Quiz Completed."
				} else {
					var notification = "Great job on that quiz!"
				}

				window.wrNotifications.triggerDropDownNotification({
					title: "Done!", text: notification, icon: "star" });				
			}

			var params = "?showDetails=true"

			CurrentUser.fetchCurrentUserCoinData();
			$wr.redirect(MyShelfRouting.getPath({
				activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
				detailsView: "quizzes",
				textID: this.textID()
			}) + params);
		});
	}
	toNextQuestion() {
		this.setState({
			questionIndex: this.state.questionIndex + 1,
			answerSaving: false
		});
	}

	quizLevel() {
		if (this.props.quiz) {
			return GradeLevel.getQuizLevel(this.props.quiz.grade_level);			
		}
	}

	iconPathStems() {
		var stems = [];
		var answers = this.props.answers;

		// Note that these icon images aren't named what they currently do

		if (answers == null || answers.length == 0) {
			if (CurrentUser.isPremiumOrTrialAccount()) { 
				_.times(this.props.userPrefs.recall_question_count, () => {
					stems.push("quiz-icons/open-ss");
				});
			}
			_.times(this.props.userPrefs.sentence_starter_count, () => {
				stems.push("quiz-icons/open-no-ss");
			});
			_.times(this.props.userPrefs.analysis_question_count, () => {
				stems.push("quiz-icons/open-no-ss");
			});
		} else {
			_.each(answers, (answer) => {
				if (answer.question_type == "fill-in-the-blank-question") {
					stems.push("quiz-icons/open-ss");
				} else if ((answer.parts || []).length > 1) {
					stems.push("quiz-icons/open-no-ss");					
				} else {
					stems.push("quiz-icons/open-no-ss");
				}
			})
		}
		return stems;
	}

	renderProgressMeter() {
		var iconStems = this.iconPathStems();

		var studentAvatar = (
			<StudentAvatar student={ CurrentUser.get() } maxWidth={ 45 } disableAnimation={true}/>
		);
		return (
			<StepProgressMeter numSteps={ iconStems.length } currentStep={ this.getPhase() }
				iconPathStems={ iconStems } currentStepDisplay={ studentAvatar }
				finishImgPath="quiz-icons/finish.png" />
		);
	}

	renderQuizCurtain(){		
		var src = require("tiers/lock.png");
		var patchImg = <img src={src} className="lockImg" />;
		return (
			<div className="curtainContainer">
				<div className="curtain">
					<div>{patchImg}</div>
					<p>
						Your teacher has restricted you from taking quizzes at this hour.
						<br />
						Wait until the next school day to start a quiz.
					</p>
				</div>
			</div>
		);
	}

	render() {
		//loadBook => false as to not send double request to matilda
		var bookHeader = (
			<header className="pageHeader">
				<h1><BookDisplay textID={ this.textID() } loadBook={false} /></h1>
			</header>
		);
		var progressMeter = this.renderProgressMeter();

		var quizLevel = this.quizLevel();

		// ASK FOR TEXT VARIETY TO TRIGGER QUIZ AND ANSWERS CREATION
		if(this.props.book && !this.props.book.text_variety){
			var pageContent = (
				<div className="textVariety">
					<header className="pageHeader">
						<h1>Select a Book Type</h1>
					</header>
					<BookTextVariety book={ this.props.book } onSelect={this.submitTextVariety.bind(this)}/>	
				</div>
			)
		} 
		else if (!this.quizID()) {
			// Waiting for the quiz to load 
			var pageContent = <Spinner placeholder={ true } scale={ 1.7 } />;

		} else if (_.isEmpty(this.props.questions) || _.isEmpty(this.props.answers)) {
			// We just finished the warm up phase and are waiting to load questions and answers
			var pageContent = <Spinner placeholder={ true } scale={ 1.7 } />;
		} else {	
			var showAnswerProgress = !CurrentUser.get().account.web_demo;
			var hasMoreQuestions = this.props.questions.length != (this.state.questionIndex + 1);
			var answer = this.props.answers[this.state.questionIndex];
			var pageContent = (
				<div>
					<Autosaver key="open-ended" textID={ this.textID() }
						onDeleteClick={ this.deleteDraft }
						autosaveLoading={ this.isLoading() }
						getAutosaveHash={ this.getAutosaveHash }
						onAutosave={ this.autosaveDraft } />

					<AnswerWritingInterface answerID={ answer.id }
						loading={ this.isLoading(true) }
						onQuestionChange={ this.changeQuestion }
						hasMoreQuestions={ hasMoreQuestions }
						onComplete={ this.onAnswerComplete }
						requestFeedbackOnQuestionChange
						showAnswerLengthMeter
						questionIndex={ this.state.questionIndex } />
				</div>
			);
		}


		// var triggerOnboarding = ($wr.getURLParameterByName("first") == "true");
		// if (triggerOnboarding) {
		// 	var redirectPath = this.props.location.pathname + "?text_id=" + this.textID();
		// 	var studentOnboardingModal = <StudentOnboardingModal writingTriggered={ true }
		// 		redirectPath={ redirectPath } />;
		// }
		if (!this.props.canTakeQuiz) {
			var content = this.renderQuizCurtain()
		}
		else {
			var content = (
				<div>
					{progressMeter}
					{pageContent}
				</div>
			)
		}
		return (
			<div className="container quizPage">
				
				{ bookHeader }
				{ content }
				
			</div>
		);
		//{ studentOnboardingModal }
 	}

	componentDidMount() {
		if (this.props.populateData) {
			this.props.populateData();
		}
	}


	// Loads a new question for quiz with same question params as old question
	changeQuestion() {
		var oldQuestion = this.props.questions[this.state.questionIndex];
		var currentQuestionIDs = _.uniq(_.pluck(this.props.questions, "id"));

		var hasStarters = (this.props.answers[this.state.questionIndex].parts || []).length > 1;

		var questionQuery = {
			sample: 1, 
			types: oldQuestion.type,
			text_varieties: this.props.quiz.text_variety,
			grade_levels: this.props.quiz.grade_level,
			exclude_ids: currentQuestionIDs.join(","),
			with_starter: hasStarters
		};

		if (oldQuestion.type == "generic-question") {
			questionQuery.skillsets = oldQuestion.skillset;
		} else {
			questionQuery.text_id = oldQuestion.text_id;
		}

		var embeds = [
			"question.starters", "question.answer_options", "question.initial_answer_parts"
		];
		this.props.getNewQuestion(questionQuery, embeds).then((response) => {
			var newQuestion = response.questions[0];
			if (!newQuestion) {
				window.wrNotifications.triggerDropDownNotification({
					text: "Sorry! This is the only question option right now.", icon: "exclamation-sign" });
				return;
			}

			var answerData = {
				draft: this.props.quiz.draft,
				allow_revision: this.props.quiz.allow_revision,
				question_id: newQuestion.id, meta_data: null,
				parts: newQuestion.initial_answer_parts,
				localParts: null,
				sessionMetaData: null, recentAutograderData: null
			};

			var currentAnswerID = this.props.answers[this.state.questionIndex].id;

			this.props.updateAnswer(currentAnswerID, answerData)
		})
	}

	getAutosaveHash() {
		var answer = this.props.answers[this.state.questionIndex];
		var question = this.props.questions[this.state.questionIndex];

		var hashString = _.pluck(answer.localParts, "text").join("|");
		hashString += "|" + question.body;
		hashString += "|" + JSON.stringify(answer.sessionMetaData);
		hashString += "|" + JSON.stringify(answer.recentAutograderData);

		var hashValue = $wr.hashCode(hashString);

		return hashValue;
	}
};

QuizPage.WrappedComponent.propTypes = PageStrictPropTypes({

	// Data from @connect
	quiz: PropTypes.object,
	answers: PropTypes.array,
	questions: PropTypes.array,
	book: PropTypes.object,
	loading: PropTypes.bool,
	userPrefs: PropTypes.object,
	shouldExclude: PropTypes.bool,
	canStudentTakeQuiz: PropTypes.bool,

	// Handlers from @connect
	populateData: PropTypes.func.isRequired,

	updateQuiz: PropTypes.func.isRequired,
	createQuizAnswers: PropTypes.func.isRequired,
	deleteQuiz: PropTypes.func.isRequired,
	getNewQuestion: PropTypes.func.isRequired,
	createNewQuiz: PropTypes.func.isRequired,

	updateAnswer: PropTypes.func.isRequired,
});

module.exports = QuizPage;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/QuizPage.js